import { render, staticRenderFns } from "./Value.vue?vue&type=template&id=5aee48fa&scoped=true&"
import script from "./Value.vue?vue&type=script&lang=js&"
export * from "./Value.vue?vue&type=script&lang=js&"
import style0 from "./Value.vue?vue&type=style&index=0&id=5aee48fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee48fa",
  null
  
)

export default component.exports